export enum TaskType {
    Simple = 'SIMPLE',
    AnimalPrevention = 'ANIMAL_PREVENTION',
    DeIcing = 'DE_ICING',
    Maintenance = 'MAINTENANCE',
    RescueService = 'RESCUE_SERVICE',
    Inspection = 'INSPECTION',
    Refuelling = 'REFUELLING',
    Terminal = 'TERMINAL',
}
